import React from 'react';
import Actions from 'providers/components/list/ProvidersActions';
import { translate } from 'react-i18next';

const ProvidersListRow = ({ company, subcompany, permissions, provider, t, handleToggle }) => {
  return (
    <tr>
      <td>{provider.key}</td>
      <td>{provider.name}</td>
      <td>{provider.mail}</td>
      <td>{provider.telephone}</td>
      <td>{provider.rfc}</td>
      <td className="text-center">{t(provider.active ? 'common.yes' : 'common.no')}</td>
      <td className="text-center">
        <Actions
          company={company}
          provider={provider}
          handleToggle={handleToggle}
          permissions={permissions}
          subcompany={subcompany}
        />
      </td>
    </tr>
  );
};

export default translate()(ProvidersListRow);



// WEBPACK FOOTER //
// src/modules/secured/modules/providers/components/list/ProvidersListRow.js